import React from "react";
import { connect } from 'react-redux';
import classes from './Informes.css';
import { Grid, Typography } from "@material-ui/core";
import BoxEjecutarPaginaInfo from '../../components/UI/BoxEjecutarPaginaInfo/BoxEjecutarPaginaInfo';
import InformesFiltros from "../../components/Indicadores/Informes/InformesFiltros";
import InformesListado from "../../components/Indicadores/Informes/InformesListado";
import InformesPaginado from "../../components/Indicadores/Informes/InformesPaginado";
import PanelMensaje from '../../components/UI/PanelMensaje/PanelMensaje';
import BoxInfo from '../../components/UI/BoxInfo/BoxInfo';

const Informes = (props) => {
  const { ejecucionPagina, loading, informes } = props;
  const consultaEjecutada = Array.isArray(informes);
  const mostrarGridSinResultados =
    !loading && consultaEjecutada && informes.length === 0;
  if (!ejecucionPagina) return <BoxEjecutarPaginaInfo />;

  return (
    <>
    <Grid container spacing={1} className={classes.panelContainer}>
      <Grid item xs={12}>
        <Typography variant="h5">
          Listado de informes
        </Typography>
      </Grid>

      {/* Los filtros siempre visibles */}
      <Grid
        item
        xs={12}
        container
        spacing={1}
        className={classes.containerFlexRow}
      >
        <InformesFiltros />
      </Grid>

      {mostrarGridSinResultados ? (
        <>
          <Grid container spacing={1} justify="center">
              <Grid item xs={12}>
                <PanelMensaje
                  text="No hay informes disponibles.
Para poder visualizar informes, primero debés configurarlos.
Ingresá a la aplicación «Alertas e Informes», seleccioná la opción «Informes» y definí los informes que querés recibir de forma automática.
Una vez configurados, podrás consultarlos desde esta pantalla.
"
                  widthPx={900}
                  iconType="alert"
                  iconAriaLabel="Aviso importante"
                />
              </Grid>
            <Grid item xs={12}>
              
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12} container spacing={1} justifyContent="center">
            <InformesListado />
          </Grid>
          <Grid item xs={12} container spacing={1} justifyContent="center">
            <InformesPaginado />
          </Grid>
        </>
      )}
    </Grid>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    ejecucionPagina: state.ejecucionPaginas.ejecucionInformes,
    loading: state.notificaciones?.loadInformes?.loading ?? false,
    informes: state.notificaciones?.loadInformes?.informes, // undefined hasta el primer fetch
  };
};

export default connect(mapStateToProps)(Informes);
